<template>
  <footer id="footer">
    <div class="footer__container">
      <div class="footer__content">
        <div class="footer__copyright">
          <span class="footer__copyright-sign">©</span> 2021 DUMP Days. Sva prava pridržana.
        </div>
        <div class="footer__social">
          <a aria-label="Posjeti stranicu DUMP-a" href="https://dump.hr" target="_blank" rel="noreferrer">
            <img src="../../assets/dump-logo.svg" alt="DUMP link" class="footer__logo" />
          </a>
          <a
            class="footer__icon footer__icon--facebook"
            aria-label="Link na facebook"
            href="https://www.facebook.com/dumpdays/"
            target="_blank"
            rel="noreferrer"
          >
            <img src="../../assets/social/facebook.svg" alt="Facebook" />
          </a>
          <a
            class="footer__icon footer__icon--instagram"
            aria-label="Link na instagram"
            href="https://www.instagram.com/dump_days/"
            target="_blank"
            rel="noreferrer"
          >
            <img src="../../assets/social/instagram.svg" alt="Instagram" />
          </a>
          <a
            class="footer__icon footer__icon--youtube"
            aria-label="Link na youtube"
            href="https://www.youtube.com/channel/UC7PMtpZobjWu84C-x_nRW5w"
            target="_blank"
            rel="noreferrer"
          >
            <img src="../../assets/social/youtube.svg" alt="Youtube" />
          </a>
          <a
            class="footer__icon footer__icon--linkedin"
            aria-label="Link na linkedin"
            href="https://hr.linkedin.com/company/dump-udruga-mladih-programera"
            target="_blank"
            rel="noreferrer"
          >
            <img src="../../assets/social/linkedin.svg" alt="Facebook" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
#footer {
  padding: 0 16px 16px 16px;
  max-width: 1440px;
  margin: auto;
}

.footer__container {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 24px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.03);
}

.footer__copyright {
  margin-bottom: 34px;
  font-size: 16px;
  line-height: 24px;
  color: #ffffffcc;
}

.footer__copyright-sign {
  font-family: 'Circular-Loom', sans-serif;
}

.footer__social {
  display: flex;
  align-items: center;
}

.footer__logo {
  width: 76px;
  height: auto;
  margin-right: 50px;
}

.footer__icon {
  margin-right: 28px;
  filter: brightness(0) invert(1);
}

.footer__icon:last-of-type {
  margin-right: 0;
}

@media screen and (min-width: 837px) {
  .footer__container {
    padding: 59px 68px;
    display: block;
  }

  .footer__content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .footer__copyright {
    margin-bottom: 0;
  }
}
</style>
